import { SEASON_PRESETS, type SeasonRegion } from '@sea-snag/shared';

const DAY_FMT = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'short',
  timeZone: 'UTC',
});

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const fmtDay = (iso: string) => DAY_FMT.format(new Date(`${iso}T00:00:00Z`));

/** "1 May – 24 Oct", from two ISO dates read as UTC days. */
export const formatSeasonRange = (from: string, to: string) => `${fmtDay(from)} – ${fmtDay(to)}`;

/** A region's default season, e.g. "May 1 – Oct 31", or "Year-round". */
export function presetSeasonLabel(region: SeasonRegion): string {
  const p = SEASON_PRESETS[region];
  if (region === 'year_round') return 'Year-round';
  return `${MONTHS[p.start.month - 1]} ${p.start.day} – ${MONTHS[p.end.month - 1]} ${p.end.day}`;
}
